const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.expansion_joints/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        case "table.expansion_joints/LIST_EXPANSION_JOINTS_SUCCESS":
            return {
                ...state,
                data: action.response.data,
                filters: action.response.filters,
                ...action.response.pagination
            };
        default:
            return state;
    }
}
